<template>
    <v-app>
        <v-main>
            <v-container v-if="!loading">
                <div style="display: flex; flex-direction: row; align-items:center; margin-bottom: 20px;">
                  <div style="display: flex; flex-direction: column;">
                    <div class="mb-auto"><h1>MyBooking Statistics</h1></div>
                    <div class="mb-2">
                      <div style="display: flex; flex-direction: row; align-items: center; margin-top: 10px;">
                        <div style="width: 80px;"><strong>Date:</strong></div>
                        <div>{{ $moment(referenceDate).format('dddd, D MMMM YYYY') }} (Week {{ $moment(referenceDate).week() }})</div>
                      </div>
                      <div style="display: flex; flex-direction: row; align-items: center;">
                        <div style="width: 80px;"><strong>Calls:</strong></div>
                        <div>{{ isEmpty(data) ? 0 : data.getStatistics.total.calls }}</div>                    
                      </div>
                    </div>                  
                  </div>
                  <v-spacer></v-spacer>
                  <div style="display: flex; flex-direction: column;">
                    <div style="display: flex; flex-direction: row; ">
                      <div style="padding-top: 20px; margin-right: 30px; width: 150px;">
                        <v-select
                          v-model="referenceDate"
                          :items="dateOptions"
                          label="Reference Date"
                          dense
                          @change="getStats()"
                        />
                      </div>  
                      <div style="padding-top: 20px; margin-right: 30px;">
                        <v-btn
                          class="ml-2"                    
                          color="primary"
                          @click="getStats()"
                          :loading="loading"
                          :disabled="loading" >
                          <v-icon class="mr-2">mdi-refresh</v-icon>Refresh data
                        </v-btn>
                      </div>    
                    </div>     
                <div style="display: flex; flex-direction: row; align-items: center; margin-top: 10px;">
                    <div style="margin-right: 10px; font-size: small; padding-top:3px;">Execution time:</div>
                    <div style="font-size: small;  padding-top:3px;">
                      {{ isEmpty(data) ? 0 : formatTotalExecutionTimeMs(data.getStatistics.total.totExecutionMs) }}
                      <span style="margin-left: 5px;">({{ isEmpty(data) ? '0.00' : (100 - calculateIdleTime(data.getStatistics.total.totExecutionMs)).toFixed(2) }}%)</span>
                    </div>
                    <div style="margin-left: 20px; margin-right: 10px; font-size: small;  padding-top:3px;">Idle time:</div>
                    <div style="font-size: small;  padding-top:3px;">{{ isEmpty(data) ? 0 : calculateIdleTime(data.getStatistics.total.totExecutionMs) }}%</div>                         
                    </div>
                </div>    
                                </div>

                <v-data-table
                  :headers="getHeaders()"
                  :items="data.getStatistics.calldata"
                  dense
                  :items-per-page="-1"
                  hide-default-footer
                >
                  <template v-slot:item="call">
                    <tr>
                      <td>{{ call.item.program }}</td>
                      <td align="end">{{ call.item.calls }}</td>
                      <td align="end">{{ call.item.avgExecutionMs }}</td>
                      <td align="end">{{ call.item.minExecutionMs }}</td>
                      <td align="end">{{ call.item.maxExecutionMs }}</td>
                      <td align="end">{{ call.item.executionMs }}</td>
                    </tr>
                  </template>
                </v-data-table>       
            </v-container>
        </v-main>
        <navBar title="Ares - Reference data" :home="true" type="referencedata"/> 
    </v-app>
</template>
<script>
import navBar from "@/components/ui/navbars/navbar.vue";
export default {
    components: {
        navBar
    },
    data() { 
      // Helper functions
        const today = new Date();
        const pad = n => n < 10 ? '0' + n : n;
        const toISO = d => d.toISOString().split('T')[0];
        const toDDMMYYYY = d => `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
        // Build dateOptions: today and 7 days back
        let dateOptions = [];
        for (let i = 0; i < 8; i++) {
          let d = new Date(today);
          d.setDate(today.getDate() - i);
          dateOptions.push({
            text: toDDMMYYYY(d),
            value: toISO(d)
          });
        }      
        return {
            data: {},
            loading: true,
            referenceDate: toISO(today),
            dateOptions,            
        }
    },
    async mounted(){
      this.getStats();
    },    
    methods: {
        isEmpty(obj){
            return Object.keys(obj).length === 0
        },
        getHeaders(){
            return [
                { text: "Program", value: "program" },
                { text: "Calls", value: "calls", align: "end", width: "10%" },
                { text: "Avg Execution (ms)", value: "avgExecutionMs", align: "end", width: "10%" },
                { text: "Min Execution (ms)", value: "minExecutionMs", align: "end", width: "10%" },
                { text: "Max Execution (ms)", value: "maxExecutionMs", align: "end", width: "10%" },
                { text: "Execution (ms)", value: "executionMs", align: "end", width: "10%" }
            ]
        },
        formatTotalExecutionTimeMs(millies){
          if (typeof millies !== "number" || isNaN(millies)) return "00:00:00:000";
          let ms = millies;
          let hours = Math.floor(ms / 3600000);
          ms = ms % 3600000;
          let minutes = Math.floor(ms / 60000);
          ms = ms % 60000;
          let seconds = Math.floor(ms / 1000);
          ms = ms % 1000;
          return (
            String(hours).padStart(2, "0") + ":" +
            String(minutes).padStart(2, "0") + ":" +
            String(seconds).padStart(2, "0") + ":" +
            String(ms).padStart(3, "0")
          );
        },
        calculateIdleTime(millies) {
            if (typeof millies !== "number" || isNaN(millies)) return 0;
            const refDate = new Date(this.referenceDate);
            const now = new Date();
            let totalMs;
            // If reference date is today, use ms since midnight; else, use 24h
            if (
            refDate.getFullYear() === now.getFullYear() &&
            refDate.getMonth() === now.getMonth() &&
            refDate.getDate() === now.getDate()
            ) {
            totalMs =
              now.getHours() * 3600000 +
              now.getMinutes() * 60000 +
              now.getSeconds() * 1000 +
              now.getMilliseconds();
            } else {
            totalMs = 24 * 3600000;
            }
            const idleMs = totalMs - millies;
            const percent = (idleMs / totalMs) * 100;
            return Math.max(0, Math.min(100, percent.toFixed(2)));
        },
        getStats(){
            this.loading=true
            this.$axios.post("ares/json/ares/syst/misc/getStatistics.p", {
            header: {
                token: this.$session.get("ARES"),
                clientSessionId: this.$session.id(),
                request: "getStatistics"
            },
            getStatistics: {
              referenceDate: this.referenceDate,
            }
            })
            .then(res => {
                this.loading = false
                this.data = res.data
                console.log(this.data)
            });            
        }
    }          
}
</script>    
<style scoped>

</style>